import { compact } from 'lodash-es';
import { getNameValidator, getEmailValidator, getCompanyNameValidator, titleValidation, composeValidators, maxLengthValidation, noHtmlPatternValidation, requiredValidation, getTitleValidator } from 'validators';
import { extractPureTextFromRichText } from 'seagull/components/RichTextEditor/RichTextEditor';
export const validateContact = {
    firstName: getNameValidator('First name', 'Please enter a first name'),
    lastName: getNameValidator('Last name', 'Please enter a last name'),
    email: getEmailValidator(undefined, 'Please enter an email address'),
    companyName: getCompanyNameValidator(undefined, 'Please enter a company name')
};
export const isNewContactValid = (contact)=>validateContact.firstName(contact.firstName) === true && validateContact.lastName(contact.lastName) === true && validateContact.companyName(contact.companyName) === true && validateContact.email(contact.email) === true;
export const validateAgreementRecipient = {
    firstName: getNameValidator('First name'),
    lastName: getNameValidator('Last name'),
    email: getEmailValidator()
};
export const agreementNameValidator = (value)=>getTitleValidator('Agreement name', 'Please provide an agreement name.')(value);
export const getOptionalAgreementNameValidator = (allowEmpty)=>(value)=>getTitleValidator('Agreement name', allowEmpty ? false : 'Please provide an agreement name.')(value);
/** For react-hook-form library. */ export const agreementNameValidation = {
    validate: {
        title: agreementNameValidator
    },
    dataAttr: {
        'data-validation': 'title'
    }
};
export const getOptionalAgreementNameValidation = (allowEmpty)=>({
        validate: {
            title: getOptionalAgreementNameValidator(allowEmpty)
        },
        dataAttr: {
            'data-validation': 'title'
        }
    });
const templateName = 'Template name';
const templateNameRequired = 'Please provide a template name';
export const templateNameValidator = getTitleValidator(templateName, templateNameRequired);
export const templateNameValidation = titleValidation(templateName, {
    required: templateNameRequired
});
export function getCustomMessageValidation(label, required) {
    return composeValidators(compact([
        required && requiredValidation('Required'),
        maxLengthValidation(4000, label),
        noHtmlPatternValidation(label)
    ]));
}
export const MAX_LEGAL_TERMS_NAME_LENGTH = 80;
export const MAX_LEGAL_TERMS_CONTENT_LENGTH = 100000;
export const validateLegalTermsName = (name)=>{
    if (name.trim() === '') return {
        valid: false,
        error: 'empty'
    };
    if (name.length > MAX_LEGAL_TERMS_NAME_LENGTH) return {
        valid: false,
        error: 'tooLong'
    };
    return {
        valid: true
    };
};
export const validateLegalTermsContent = (contentDelta)=>{
    if (contentDelta == null) return {
        valid: true
    };
    if (extractPureTextFromRichText(contentDelta).length > MAX_LEGAL_TERMS_CONTENT_LENGTH) {
        return {
            valid: false,
            error: 'tooLong'
        };
    }
    return {
        valid: true
    };
};
export const validateViaRHF = (rule, value)=>{
    const validators = rule.validate;
    if (!validators || typeof validators !== 'object') return undefined;
    for (const validator of Object.values(validators)){
        if (typeof validator === 'function') {
            const result = validator(value !== null && value !== void 0 ? value : '');
            if (result !== true && typeof result === 'string') {
                return result;
            }
        }
    }
};
